import React, { Component } from "react";
import * as loginActions from "./actions";
import "./profile.css";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  Modal,
  Table,
  Tag,
  Divider,
  Button,
  Drawer,
  Form,
  Col,
  Row,
  Input,
  Select,
  DatePicker,
  Icon,
  Skeleton,
  AutoComplete,
  Card
} from "antd";
import GenTable from "./genTable";
const { Option, OptGroup } = AutoComplete;
const { TextArea } = Input;

class Teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      isLoaded: false,
      selectedStudents: [],
      selectedStudentsInput: []
    };
  }
  showDrawer = selectedStudents => {
    this.setState({
      selectedStudents,
      selectedStudentsInput: selectedStudents.map(el => el.UID),
      visible: true
    });
  };

  handleChange = selectedStudentsInput => {
    this.setState({ selectedStudentsInput });
  };

  onClose = () => {
    this.setState({
      visible: false,
      selectedStudents: [],
      selectedStudentsInput: []
    });
  };

  componentWillUnmount() {
    this.props.onUnload();
  }
  
  componentWillMount() {
      this.props.loadStudentList();
    }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.addTeam(values);
      }
    });
  };

  render() {
    const {
      getFieldDecorator,
      getFieldValue,
      validateFields
    } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      }
    };
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 20, offset: 4 }
      }
    };

    const onValidateForm = e => {
      e.preventDefault();
      validateFields((err, values) => {
        if (!err) {
          this.props.addTeam(values);
          this.onClose();
        }
      });
    };
    return (
      <>
        <div
          style={{
            marginTop: 63
          }}
        >
          <h1 className="heading">Create Teams</h1>

          <Card title={"List of Students"} style={{  margin: 20 }} bordered={true}>
          <Skeleton
            active={!this.props.studentList.valid}
            loading={!this.props.studentList.valid}
          >
            {this.props.studentList.valid ? (
              <GenTable
                branch={this.props.userBranch} campus={this.props.userCampus}
                props={this.props}
                data={
                  this.props.studentList.data ? this.props.studentList.data : []
                }
                showDrawer={this.showDrawer}
              />
            ) : null}
          </Skeleton>
          </Card>
        </div>
        <Drawer
          title="Add new HOD"
          width={720}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <Form layout="vertical" onSubmit={this.handleSubmit}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Team Name">
                  {getFieldDecorator("teamName", {
                    rules: [
                      { required: true, message: "Please enter team name" }
                    ]
                  })(<Input placeholder="Please enter team name" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Team Discription">
                  {getFieldDecorator("teamDiscription", {
                    rules: [
                      { required: true, message: "Please enter team discription" }
                    ]
                  })(<TextArea placeholder="Please enter team discription (A small detail about team)" />)}
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Members">
                  {getFieldDecorator("members", {
                    initialValue: this.state.selectedStudentsInput,
                    rules: [
                      { required: true, message: "Please choose your campus" }
                    ]
                  })(
                    <Select
                      showSearch
                      mode="multiple"
                      size="large"
                      placeholder="Select Members"
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={this.handleChange}
                    >
                      {this.props.studentList.data
                        ? this.props.studentList.data.map(el => (
                            <Option value={el.UID} key={el.UID}>
                              {el.displayName}
                            </Option>
                          ))
                        : null}
                    </Select>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <div
            style={{
              position: "absolute",
              left: 0,
              bottom: 0,
              width: "100%",
              borderTop: "1px solid #e9e9e9",
              padding: "10px 16px",
              background: "#fff",
              textAlign: "right"
            }}
          >
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" onClick={onValidateForm} htmlType="submit">
              Submit
            </Button>
          </div>
        </Drawer>
      </>
    );
  }
}

const WrappedTeams = Form.create({ name: "dynamic_form_item" })(Teams);

const mapStateToProps = state => {
  

  return {
    studentList: state.auth.studentList
  };
};

const mapDispachToProps = (dispatch, props) => ({
  addTeam: formval => {
    dispatch(loginActions.addTeam(formval));
  },
  removeHOD: email => {
    dispatch(loginActions.removeHOD(email));
  },
  loadStudentList: () => {
    dispatch(loginActions.loadStudentList());
  },
  onUnload: () =>
  dispatch({ type: "HOME_PAGE_UNLOADED" })
});

export default connect(
  mapStateToProps,
  mapDispachToProps
)(WrappedTeams);
